<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="closeDialog()" @keydown.esc="closeDialog()" fullscreen
      transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-on:submit.prevent="importar($event)">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text style="margin-bottom: 80px;">
            <!-- START FORM DIALOG -->
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col md="10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
                <a-steps :current="step">
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
              </v-col>
            </v-row>

            <div class="steps-content">
              <!--step 0-->
              <v-row align="start" justify="center" v-if="step == 0" transition="fade-transition">
                <v-col md="6" class="mt-4 pr-0 pl-0 ">
                  <v-form ref="form_step0" class="form-step0-excel">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[0].title }}</b>
                      </p>
                    </div>
                    <v-label>
                      Descargar la plantilla de importacion de envíos.
                      <v-label @click="downloadExcel" class="text-download font-weight-bold ms-1 me-1">
                        Descargar
                      </v-label>

                    </v-label>

                    <v-file-input class="mt-3" accept=".xlsx" label="Seleccionar excel" v-model="excelFile"
                      hint="Solo admite archivos formato .xlsx (No admite formato .xls)" persistent-hint></v-file-input>
                  </v-form>

                </v-col>
              </v-row>

              <!--step 2-->
              <v-row align="start" justify="center" v-if="step == 1" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step1">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[1].title }}</b>
                      </p>
                    </div>
                    <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important"
                      class="mb-3 mt-3">
                      <strong>{{ Math.ceil(percent) || 0 }}%</strong>
                    </v-progress-linear>

                    <v-data-table :headers="headers" :items="list_bulk" :search="search" :loading="loading_table"
                      class="simple-table" :items-per-page="5" dense>
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>{{ item.object.client_username }}</td>
                          <td>{{ item.object.almacen_code }}</td>
                          <td>{{ item.object.lpn_code }}</td>
                          <td>{{ item.object.ubicacion_code }}</td>
                          <td>{{ item.object.sku }}</td>
                          <td>{{ item.object.stock }}</td>
                          <td>{{ item.object.entry_date }}</td>
                          <td>{{ item.object.lote }}</td>
                          <td>{{ item.object.quality }}</td>
                          <td>{{ item.object.serie }}</td>
                          <td>{{ item.object.expiration_date }}</td>
                          <td v-if="isAliasEnabled('descriptivo_1')">{{ item.object.descriptivo_1 }}</td>
                          <td v-if="isAliasEnabled('descriptivo_2')">{{ item.object.descriptivo_2 }}</td>
                          <td v-if="isAliasEnabled('descriptivo_3')">{{ item.object.descriptivo_3 }}</td>
                          <td style="min-width: 200px">
                            <span v-if="item.loading">Procesando...</span>
                            <span v-else-if="item.status == 1 && item.status_create" class="text-green">Importado</span>
                            <span v-else-if="item.status == 1 && !item.status_create" class="text-red">{{ item.msg
                              }}</span>
                            <span v-else-if="item.status == 0">Pendiente de procesado</span>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <!-- <v-row>
                      <v-col cols="6" class="text-end">
                        <v-label class="msg-success">Importaciones creadas: {{ importaciones_creadas }}</v-label>

                      </v-col>
                      <v-col cols="6">
                        <v-label class="msg-error">Importaciones fallidas: {{ importaciones_no_creadas }}</v-label>
                      </v-col>
                    </v-row> -->

                    <!-- <v-btn class="float-right mt-5 btn-second" v-if="step < steps.length - 1" @click="next">Siguiente</v-btn> -->
                  </v-form>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions style="position: fixed; bottom: 0; right: 0; left: 0;">
            <v-row align="start" justify="center">
              <v-col cols="10" style="background-color: white;">

                <v-btn @click="prev" color="blue-grey" variant="outlined" v-if="step > 0">Atras</v-btn>
                <div class="float-right mr-2" v-if="step == 1">
                  <v-btn v-if="importaciones_no_creadas  > 0" @click="downloadErrorsExcel"  variant="outlined" color="primary" class="mr-2">
                    <v-icon left>mdi-download</v-icon>
                    Descargar Errores
                  </v-btn>
                  <v-chip color="success" class="mr-2">Importadas: {{ importaciones_creadas }}</v-chip>
                  <v-chip color="error" class="">Fallidas: {{ importaciones_no_creadas}}</v-chip>
                </div>

                <v-btn class="float-right" variant="outlined" color="primary" @click="readExcel" v-if="step == 0"
                  :disabled="excelFile == null && step == 0"> Siguiente</v-btn>

              </v-col>
              <v-col cols="12" style="background-color: #fafafa;border-top: 1px solid #c1c1c1;" class="text-end">
                <v-btn color="error" text @click="closeDialog()">Cerrar</v-btn>
                <v-btn color="success" text type="submit" :disabled="submit_disabled" :loading="loading"
                  v-if="!disabled && step == 1">{{ formBtn
                  }}</v-btn>

              </v-col>
            </v-row>

          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import readXlsxFile from "read-excel-file";


export default {
  components: {},
  mixins: [ValidMixin, ExportMixin, AliasMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      step: 0,
      steps: [
        {
          title: "Importar Excel",
          description: "Importe el Excel",
          content: "First-content",
        },
        {
          title: "Detalle del Excel",
          description: "Detalle del Excel",
          content: "Second-content",
        },
      ],
      excelFile: null,
      list_bulk: [],
      loading_create: false,
      importaciones_creadas: 0,
      importaciones_no_creadas: 0,
      total_importaciones: 0,
      submit_disabled: false,
      progress: 0,
      loading_table: false,
    };
  },
  watch: {

  },
  mounted() {
  },

  computed: {
    headers() {
      const baseHeaders = [
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client_username",
        },
        {
          title: "Almacén",
          align: "left",
          sortable: true,
          key: "almacen_code",
        },
        {
          title: "LPN",
          align: "left",
          sortable: true,
          key: "lpn_code",
        },
        {
          title: "Ubicación",
          align: "left",
          sortable: true,
          key: "ubicacion_code",
        },
        {
          title: "SKU",
          align: "left",
          sortable: true,
          key: "sku",
        },
        {
          title: "Stock",
          align: "left",
          sortable: true,
          key: "stock",
        },
        {
          title: "Fecha de Ingreso",
          align: "left",
          sortable: true,
          key: "entry_date",
        },
        {
          title: "Lote",
          align: "left",
          sortable: true,
          key: "lote",
        },
        {
          title: "Calidad",
          align: "left",
          sortable: true,
          key: "quality",
        },
        {
          title: "Serie",
          align: "left",
          sortable: true,
          key: "serie",
        },
        {
          title: "Fecha de Expiración",
          align: "left",
          sortable: true,
          key: "expiration_date",
        },
      ];

      // Agregar descriptivos dinámicamente si están habilitados
      for (let i = 1; i <= 3; i++) {
        const descriptiveKey = `descriptivo_${i}`;
        if (this.isAliasEnabled(descriptiveKey)) {
          baseHeaders.push({
            title: this.getAliasName(descriptiveKey),
            align: "left",
            sortable: true,
            key: descriptiveKey,
          });
        }
      }

      // Agregar header de resultado
      baseHeaders.push({
        title: "Resultado",
        align: "left",
        sortable: false,
        key: "msg"
      });

      return baseHeaders;
    },
    percent: {
      get() {
        return ((this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
  },

  methods: {
    downloadExcel() {
      const params = {}; // Agregar parámetros si son necesarios
      const fileName = 'plantilla_ajuste_manual.xlsx';

      this.exportExcel(
        this.service.section + '/get-sample-excel',
        params,
        fileName
      );
    },
    getProcesadosValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && element.status_create).length;
    },
    getProcesadosNoValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && !element.status_create).length;
    },

    async readExcel() {
      this.step++;
      this.list_bulk = [];
      this.loading_table = true;
      try {
        const rows = await readXlsxFile(this.excelFile);

        for (const element of rows.slice(1)) { // Saltar el header
          const obj = {
            object: this.parseObject(element),
            msg: "",
            status: 0,
            status_create: false,
            loading: false,
          };
          this.list_bulk.push(obj);
        }

        this.total_importaciones = this.list_bulk.length;
      } catch (error) {
        console.error(error);
      }
      finally {
        this.loading_table = false;

      }
    },
    parseObject(element) {
      const object = {
        client_username: element[0] ? element[0].toString() : '',
        almacen_code: element[1] ? element[1].toString() : '',
        lpn_code: element[2] ? element[2].toString() : '',
        ubicacion_code: element[3] ? element[3].toString() : '',
        sku: element[4] ? element[4].toString() : '',
        stock: element[5] ? parseInt(element[5]) : 0,
        entry_date: element[6] ? this.formatDate(element[6]) : '',
        storage_units_amount: element[7] ? parseInt(element[7]) : 0,
        lote: element[8] ? element[8].toString() : '',
        quality: element[9] ? element[9].toString() : '',
        serie: element[10] ? element[10].toString() : '',
        expiration_date: element[11] ? this.formatDate(element[11]) : '',
        descriptivo_1: element[12] ? element[12].toString() : '',
        descriptivo_2: element[13] ? element[13].toString() : '',
        descriptivo_3: element[14] ? element[14].toString() : '',
      };

      return object;
    },

    formatDate(dateValue) {
      if (!dateValue) return '';

      // Si es una fecha de Excel (número)
      if (typeof dateValue === 'number') {
        const date = new Date((dateValue - 25569) * 86400 * 1000);
        return date.toISOString().split('T')[0];
      }

      // Si ya es una fecha válida
      if (dateValue instanceof Date) {
        return dateValue.toISOString().split('T')[0];
      }

      // Si es string, intentar parsearlo
      if (typeof dateValue === 'string') {
        const parsedDate = new Date(dateValue);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toISOString().split('T')[0];
        }
      }

      return '';
    },

    closeDialog() {
      this.$emit("updateDialog", false);
      this.step = 0;
      this.list_bulk = [];
      this.excelFile = null;
      this.importaciones_creadas = 0;
      this.importaciones_no_creadas = 0;
      this.total_importaciones = 0;
      this.submit_disabled = false;
      this.loading = false;
      this.loading_create = false;
    },
    prev() {
      this.step--;
    },

    async importar() {
      var index = 0;
      this.loading_create = true;
      this.submit_disabled = true;

      for (const element of this.list_bulk) {
        if (this.list_bulk[index].msg == "" && !this.list_bulk[index].status_create && this.list_bulk[index].status == 0) {
          this.list_bulk[index].loading = true;
          let result = await this.createItem(this.list_bulk[index].object);

          this.list_bulk[index].loading = false;
          this.list_bulk[index].status = 1;
          this.list_bulk[index].status_create = result.status;
          this.list_bulk[index].msg = result.msg;

          if (result.status) {
            this.importaciones_creadas++;
          } else {
            this.importaciones_no_creadas++;
          }

        }

        index++;
      }

      this.loading_create = false;

      if (this.importaciones_creadas === this.list_bulk.length) {
        this.closeDialog();
        this.step = 0;
        this.list_bulk = [];
        this.excelFile = null;
        this.importaciones_creadas = 0;
        this.importaciones_no_creadas = 0;
        this.total_importaciones = 0;
        this.$emit('loadList');
      }

    },
    async createItem(item) {
      try {
        const response = await this.service.import_line_excel(item);
        return {
          status: response.status,
          msg: response.message || (response.status ? 'Importación exitosa' : 'Error en la importación:' + response.msg)
        };
      } catch (error) {
        return {
          status: false,
          msg: error.message || 'Error en la importación'
        };
      }
    },

    downloadErrorsExcel() {
      const errorsData = this.list_bulk.filter(item =>
        item.status === 1 && !item.status_create
      );

      if (errorsData.length === 0) {
        this.$toast.warning('No hay errores para descargar', 'Aviso');
        return;
      }

      // Usar el endpoint unificado del backend
      const params = {
        errors_data: errorsData
      };
      const fileName = 'errores_importacion_stock.xlsx';

      this.exportExcel(
        this.service.section + '/get-sample-excel',
        params,
        fileName
      );
    },
  },
};
</script>

<style scoped>
.text-download {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}

.text-download:hover {
  color: #1565c0;
  text-decoration: none;
}
</style>